import styled from 'styled-components';

const StyledMainTitle = styled.h1`
  font-family: 'Roboto Mono', monospace;
  font-size:x-large;
`;

const StyledSecondTitle = styled.h2`
  font-family: 'Open Sans', sans-serif;
  font-size:medium;
`;

const StyledText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size:small;
`

const InstaCaption = styled.p`
  padding:0px 20px;
  font-family: 'Open Sans', sans-serif;
  font-size:small;
  color:#4D4D4F;
`

export {
  StyledMainTitle,
  StyledSecondTitle,
  StyledText,
  InstaCaption
}
